import { render } from "./DailytReportByClient.vue?vue&type=template&id=58e256c9&scoped=true"
import script from "./DailytReportByClient.vue?vue&type=script&lang=js"
export * from "./DailytReportByClient.vue?vue&type=script&lang=js"

import "./DailytReportByClient.vue?vue&type=style&index=0&id=58e256c9&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e256c9"]])

export default __exports__